const ID = 'dialog-email-configuration';

const DEFAULT_VALUE = {
  to: '',
  cc: '',
  bcc: '',
  subject: '',
  body: '',
  actionLink: '',
  actionText: '',
  attachments: '',
};

const CHECKBOX_KEYS = ['cc', 'bcc', 'attachments'];

export { ID, DEFAULT_VALUE, CHECKBOX_KEYS };
